import React from "react"
import PropTypes from "prop-types"

// Page wrapper used by gatsby-browser / gatsby-ssr wrapPageElement.
// Framer Motion page fades were removed — they caused a white flash / blank
// screen on Chrome hydrate (opacity starts at 0).

const SiteLayout = ({ children }) => {
  return <>{children}</>
}

SiteLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SiteLayout
